// utils/intercomUtils.js
import { isHaddockEnvironment } from "utils/documentUtils";
const APP_ID = "nzk8tbj7";

// Detecta entorno local
const isLocalEnv = () =>
	typeof window !== "undefined" &&
	(window.location.hostname === "localhost" ||
		window.location.hostname.startsWith("127.") ||
		window.location.hostname.endsWith(".local"));

// Boot o update (según corresponda)
export const bootIntercom = (user) => {
	// En Haddock el soporte se gestiona con Zendesk Messaging, no con Intercom.
	if (isHaddockEnvironment()) {
		shutdownIntercom();
		return;
	}

	// console.log("Boot Intercom");
	// if (isLocalEnv()) {
	// 	console.info('Intercom desactivado en entorno local');
	// 	return;
	// }

	// if (!window?.Intercom || !user?.id) return;

	const partner_company_id = null;
	const partner = null;
	const company = user.company || null;
	const planType = user?.subscription?.subscription_type;
	// console.log(user);
	// console.log(user.company);
	// console.log(planType);

	const payload = {
		app_id: APP_ID,
		user_id: String(user.id),
		email: user.email,
		name: `${user.name || ""} ${user.surname || ""}`.trim(),
		rol: user.position || null,
		partner_company_id,
		partner,
		custom_attributes: {
			partner_company_id,
			partner,
		},
	};

	if (company) {
		payload.company = {
			id: String(company.id),
			name: company.name,
			plan: planType?.name || "Desconocido",
			size: user?.subscription?.max_users || null,
			website: company.web || null,
			partner_company_id,
			partner,
			custom_attributes: {
				partner_company_id,
				partner,
				vat_number: company.vat_number,
				address: company.address || null,
				postal_code: company.postal_code || null,
				province: company.province || null,
				city: company.city || null,
				country: company.country_iso || null,
				phone: company.phone || null,
				email: company.email || null,
			},
		};
	}

	// console.log("payload");
	// console.log(payload);

	if (window.__INTERCOM_BOOTED__) {
		// console.log("Actualizando Intercom");
		window.Intercom("update", payload);
	} else {
		console.log("Iniciando Intercom");
		window.Intercom("boot", payload);
		window.__INTERCOM_BOOTED__ = true;
	}
};

// Update ligero al cambiar de ruta
// export const updateIntercom = () => {
// 	if (window?.Intercom && window.__INTERCOM_BOOTED__) {
// 		console.log('Actualizando Intercom');
// 		window.Intercom('update');
// 	}
// };

// Enviar evento personalizado a Intercom
export const trackIntercomEvent = (eventName, metadata = {}) => {
	if (!window?.Intercom || !window.__INTERCOM_BOOTED__) return;
	window.Intercom("trackEvent", eventName, metadata);
};

// Cerrar sesión limpia
export const shutdownIntercom = () => {
	if (window?.Intercom) {
		console.log("Cerrando sesión de Intercom");
		window.Intercom("shutdown");
		window.__INTERCOM_BOOTED__ = false;
	}
};
